import { render, staticRenderFns } from "./wv-verify-email-report.vue?vue&type=template&id=22c8a83a&scoped=true&"
import script from "./wv-verify-email-report.vue?vue&type=script&lang=js&"
export * from "./wv-verify-email-report.vue?vue&type=script&lang=js&"
import style0 from "./wv-verify-email-report.vue?vue&type=style&index=0&id=22c8a83a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8a83a",
  null
  
)

export default component.exports